import { isDefined } from "@perxis-auto/shared/lib/lib/is/isDefined";
const calculatePercentageOfValue = (x, y) => {
  if (!isDefined(x) || !isDefined(y)) {
    return null;
  }
  return x / y * 100;
};
export {
  calculatePercentageOfValue
};
